import MenuSitio from "../../../components/menu/MenuSitioResponsive";
import IconosIzquierda from "./iconos_izquierda";
import IconosCentrales from "./iconos_centrales";
import IconosDerecha from "./iconos_derecha";
import Buscar from "./buscar";
import {ErrorBoundary} from "react-error-boundary";
import ErrorMessageNotifications from "../../../components/Errores/ErrorMessageNotifications";
export default function Header() {
  return (
    <>
      <div className="container-fluid header_nav" id="headerline">
          <div className="row justify-content-between">
            <IconosIzquierda/>
            <div className="col-sm-12 col-md-6 text-center wow fadeInRight animated px-0" data-wow-delay="0s" data-wow-duration="600ms" >
              <IconosCentrales/>     
            </div>
            <IconosDerecha/>
          </div>
          <div className="row back_blue nav_area">
            <div className=" col-12 col-lg-8 text-center order-2 order-lg-1 d-md-flex justify-content-center">
              <nav className=" navbar navbar-expand-lg text-center back_blue_nav navbar-dark py-0">  
              <div className=" container-fluid navbarMenuMain px-0"> 
                    <div id="navbarSupportedContent"> 
                    <ErrorBoundary FallbackComponent={ErrorMessageNotifications}>
                        <MenuSitio/> 
                      </ErrorBoundary>   
                    </div>
                </div>          
              </nav>
            </div>
            <Buscar/>
          </div>
      </div><br/>
    </>
  );
}
